import { Service, inject } from '@angular/core'
import {
  BasicEntityInfo,
  GetEntitiesQuery,
  GetEntitiesResponse,
  GetEntityAnnouncementResponse,
} from '@seiri/shared/common'
import { ApiService } from '../api.service'

@Service()
export class PublicEntityApiService {
  private readonly api = inject(ApiService)

  getEntities(query: GetEntitiesQuery, init?: RequestInit) {
    const url = this.api.createURL(`entities`)
    url.search = this.api.toQueryParams(query)
    return this.api.fetchJson<GetEntitiesResponse>(url, { ...init })
  }

  getEntity(entityId: string, init?: RequestInit) {
    return this.api.fetchJson<BasicEntityInfo>(`entities/${entityId}`, { ...init })
  }

  getAnnouncement(entityId: string, init?: RequestInit) {
    return this.api.fetchJson<GetEntityAnnouncementResponse>(`entities/${entityId}/announcement`, { ...init })
  }
}
